<button pso-button color="supporting-5-light-blue" size="s" [disabled]="disabled" [style.margin.px]="0">
  <wchfs-icon svgIcon="pso-legacy:arrow-form-left" color="white" size="16"></wchfs-icon>
  <ng-content></ng-content>
</button>
